<template>
	<VueDatePicker
		v-model="model"
		:input-attrs="{ id }"
		:formats="{ input: 'dd-MM-yyyy', preview: 'dd-MM-yyyy' }"
		:text-input="{ format: parseDate }"
		timezone="utc"
		model-type="iso"
		auto-apply
		:time-config="{ enableTimePicker: false }"
		@internal-model-change="emit('change', $event)"
	></VueDatePicker>
</template>

<script setup lang="ts">
import { VueDatePicker } from "@q-food/datepicker";

defineProps<{
	id?: string;
}>();

// Loosely typed to match the untyped schema value the host binds via v-model.
const model = defineModel<any>();

const emit = defineEmits<{
	(e: "change", value: unknown): void;
}>();

// Quick date entry for the text input: accepts "d"/"dd" (day only, current month+year),
// "ddmm" (current year), "ddmmyy" (20yy) or "ddmmyyyy". Any non-digits are stripped.
// Built in UTC to match timezone="utc" — a local Date would shift the day back in +offset zones.
function parseDate(value: unknown) {
	const digits = String(value ?? "").replace(/\D/g, "");
	if (!digits) return null;

	const now = new Date();
	let day, month, year;

	if (digits.length <= 2) {
		day = +digits;
		month = now.getMonth() + 1;
		year = now.getFullYear();
	} else if (digits.length <= 4) {
		day = +digits.slice(0, 2);
		month = +digits.slice(2, 4);
		year = now.getFullYear();
	} else if (digits.length <= 6) {
		day = +digits.slice(0, 2);
		month = +digits.slice(2, 4);
		year = 2000 + +digits.slice(4, 6);
	} else {
		day = +digits.slice(0, 2);
		month = +digits.slice(2, 4);
		year = +digits.slice(4, 8);
	}

	const d = new Date(Date.UTC(year, month - 1, day));
	// reject impossible dates like 31/02 or month 13
	if (d.getUTCFullYear() !== year || d.getUTCMonth() !== month - 1 || d.getUTCDate() !== day) {
		return null;
	}
	return d;
}
</script>
